import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import WindowSize from 'components/WindowSize';

import {
	Wrapper,
	Popup,
	Header,
	Content,
	Footer,
	Button,
	PADDING,
} from './styles';

const MODAL_ID = 'modal';

const addPortal = () => {
	const portal = document.createElement('div');
	portal.id = MODAL_ID;
	document.body.appendChild(portal);
	return portal;
};

const getPortal = () => {
	return document.getElementById(MODAL_ID) || addPortal();
};

class Modal extends Component {
	static propTypes = {
		children: PropTypes.node,
		title: PropTypes.node,
		cancelLabel: PropTypes.node,
		submitLabel: PropTypes.node,
		onSubmit: PropTypes.func,
		onClose: PropTypes.func,
		isOverlay: PropTypes.bool,
		isFullscreen: PropTypes.bool,
		width: PropTypes.string,
		zIndex: PropTypes.string,
	};

	static defaultProps = {
		isOverlay: true,
		isFullscreen: false,
	};

	portal = this.props.isOverlay ? getPortal() : null;

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyDown);
	}

	render() {
		const {
			children,
			title,
			cancelLabel,
			submitLabel,
			onSubmit,
			className,
			isOverlay,
			isFullscreen,
			width,
			zIndex,
		} = this.props;
		const hasContent = Boolean(children);
		const hasHeader = Boolean(title);
		const hasCancel = Boolean(cancelLabel);
		const hasSubmit = Boolean(submitLabel);
		const hasFooter = hasCancel || hasSubmit;
		const canSubmit = !Boolean(onSubmit);

		const popupProps = {
			onClickOutside: this.handleClickOutside,
			className,
			popupwidth: width,
		};

		const contentNode = hasContent ? (
			<React.Fragment>
				{hasHeader && <Header>{title}</Header>}
				<Content>{children}</Content>
				{hasFooter && (
					<Footer hasCancel={hasCancel} hasSubmit={hasSubmit}>
						{hasCancel && (
							<Button type="button" onClick={this.handleCancel}>
								{cancelLabel}
							</Button>
						)}
						{hasSubmit && (
							<Button
								type="submit"
								disabled={canSubmit}
								onClick={this.handleSubmit}
							>
								{submitLabel}
							</Button>
						)}
					</Footer>
				)}
			</React.Fragment>
		) : null;

		const modalNode = hasContent ? (
			<Wrapper isOverlay={isOverlay} zIndex={zIndex}>
				{isFullscreen ? (
					<WindowSize>
						{({ width, height }) => (
							<Popup
								{...popupProps}
								style={{
									width: `calc(${width}px - ${PADDING} - ${PADDING})`,
									height: `calc(${height}px - ${PADDING} - ${PADDING})`,
									overflowY: 'auto',
								}}
							>
								{contentNode}
							</Popup>
						)}
					</WindowSize>
				) : (
					<Popup {...popupProps}>{contentNode}</Popup>
				)}
			</Wrapper>
		) : null;

		if (!isOverlay) return modalNode;
		return modalNode ? ReactDOM.createPortal(modalNode, this.portal) : null;
	}

	close() {
		if (this.props.onClose) this.props.onClose();
	}

	handleKeyDown = event => {
		if (!this.props.children) return;
		if (event.keyCode === 27) this.close();
	};

	handleClickOutside = () => this.close();

	handleCancel = () => this.close();

	handleSubmit = event => {
		event.preventDefault();
		this.props.onSubmit();
	};
}

export default Modal;
